(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-content"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.carousel-content slideshow-slides').forEach(function (track) {
      var mq = window.matchMedia('(max-width: 749px)');

      function applySnap(e) {
        if (e.matches) {
          track.style.setProperty('scroll-snap-type', 'x mandatory');
        } else {
          track.style.removeProperty('scroll-snap-type');
        }
      }

      // Set initial state
      applySnap(mq);

      // React to viewport changes
      if (mq.addEventListener) {
        mq.addEventListener('change', applySnap);
      } else {
        // Safari < 14 fallback
        mq.addListener(applySnap);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
